import {CreateInstance} from './config'
const ConnDeviceGroupAPI = CreateInstance('conn-device-groups')
export default ConnDeviceGroupAPI
